import { Block, BlockProps } from './block';
import { ButtonGroup, ButtonGroupProps } from './button-group';
import { Form, FormProps } from './form';
import { Header, HeaderProps } from './header';
import { MobilePreview, MobilePreviewTemplate, MobilePreviewProps } from './mobile-preview';
import { Root } from './root';
import { Shell } from './shell';
import { Title, TitleProps } from './title';

export const AnyChatForm = {
  Root,
  Header,
  Shell,
  MobilePreview,
  Form,
  Title,
  Block,
  ButtonGroup,
  TextPreview: MobilePreviewTemplate.TextPreview,
};

export type { HeaderProps as AnyChatFormHeaderProps };
export type { BlockProps as AnyChatFormBlockProps };
export type { FormProps as AnyChatFormProps };
export type { MobilePreviewProps as AnyChatFormMobilePreviewProps };
export type { TitleProps as AnyChatFormTitleProps };
export type { ButtonGroupProps as AnyChatFormButtonGroup };
